import React, { useState, useCallback } from 'react';
import i18next from 'i18next';
import { ButtonSecondary, ButtonContent, ButtonPrimary } from '../../../StyledComponents/Button';
import { RepeatTiny } from '../../../StyledComponents/Repeat';

interface ToggleItemProps {
  title: string;
  value: string;
  type: 'tel' | 'mailto';
  href?: string;
  primary?: boolean;
  onClickVisible?: () => void;
  onClickValue?: () => void;
}

const ToggleItem = ({
  title,
  value,
  href,
  type,
  primary,
  onClickVisible,
  onClickValue,
}: ToggleItemProps) => {
  const [visible, setVisible] = useState(false);

  const _onClickValue = useCallback(() => {
    if (onClickValue) {
      onClickValue();
    }
  }, []);

  const onClick = useCallback(() => {
    if (!visible) {
      setVisible(true);
      if (onClickVisible) {
        onClickVisible();
      }
    }
  }, [visible]);

  const visibleTitle =
    type === 'tel'
      ? i18next.t('item.actions.callNumber')
      : type === 'mailto'
      ? i18next.t('item.actions.sendEmailTo')
      : '';

  return (
    <RepeatTiny>
      {visible ? (
        primary ? (
          <ButtonPrimary
            onClick={_onClickValue}
            as="a"
            href={`${type}:${href || value}`}
            title={`${visibleTitle} ${value}`}
            fullWidth
            $breakWord
          >
            <ButtonContent>{value}</ButtonContent>
          </ButtonPrimary>
        ) : (
          <ButtonSecondary
            onClick={_onClickValue}
            as="a"
            href={`${type}:${href || value}`}
            title={`${visibleTitle} ${value}`}
            fullWidth
            $breakWord
          >
            <ButtonContent>{value}</ButtonContent>
          </ButtonSecondary>
        )
      ) : primary ? (
        <ButtonPrimary onClick={onClick} title={title} fullWidth>
          <ButtonContent>{title}</ButtonContent>
        </ButtonPrimary>
      ) : (
        <ButtonSecondary onClick={onClick} title={title} fullWidth>
          <ButtonContent>{title}</ButtonContent>
        </ButtonSecondary>
      )}
    </RepeatTiny>
  );
};

export default ToggleItem;
